export const modelLabel = {
    models: [
        {label:'Llama Normal', value:'llama-normal'}, 
        {label:'Llama Finetune', value:'llama-finetune'}, 
        {label:'GPT4O MINI', value:'gpt-4o-mini'}, 
    ]
 }; 

 export const languageList = [
    {label:'English', value:'en'},
    {label:'हिंदी', value:'hi'},
    {label:'ಕನ್ನಡ', value:'kn'},
    {label:'తెలుగు', value:'te'},
];

export const sessionFlowName = {
    GuestDiscussion: 'guest-discussion',
    LoginDiscussion:'login-discussion',
    GuestMiStory: 'guest-mi-story',
    LoginMiStory: 'login',
    Reflection: 'reflection'

}